var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.333 13v-2h-9V2h-2v9h-9v2h9v9h2v-9h9z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi4zMzMzIDEzTDIyLjMzMzMgMTFMMTMuMzMzMyAxMUwxMy4zMzMzIDJMMTEuMzMzMyAyTDExLjMzMzMgMTFMMi4zMzMyNSAxMUwyLjMzMzI1IDEzTDExLjMzMzMgMTNMMTEuMzMzMyAyMkwxMy4zMzMzIDIyTDEzLjMzMzMgMTNMMjIuMzMzMyAxM1oiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";
export { SvgPlus as ReactComponent };